import { JsonProposal, Proposal } from '@ankor-io/common/proposal/Proposal'
import { ProposalDeserializer } from '@/services/proposal/deserializer/ProposalDeserializer'


/**
 * Wave service definition
 */
export type WaveService = {
  /**
   * Get the proposal by booking id
   *
   * @param bookingId the bookind id for which to get the proposal
   * @returns the json proposal or null if not found
   */
  getProposal: (bookingId: string) => Promise<Proposal | null>
}

const getProposal = async (bookingId: string): Promise<Proposal | null> => {

  const res: Response = await fetch(`/wave/${bookingId}`, {
    method: 'GET',
  })

  if (res.status === 200) {
    const jsonProposal: JsonProposal = await res.json<JsonProposal>()
    return Promise.resolve(ProposalDeserializer.deserialize(jsonProposal))
  }
  // something went wrong, return null
  return Promise.resolve(null)
}

/**
 * This is required since inject only works in vue components
 */
export const useWaveService = (): WaveService => {
  return {
    getProposal: getProposal,
  } as WaveService
}
